'use client';

import { Icon } from '@petsmart-ui/sparky';
import { useRef, useState } from 'react';

import type { DropdownNavigationItem } from '../../../../types';
import { NavigationItemLabel } from './navigation-item-label';
import { splitTriggerProps, type TriggerRenderProps, type TriggerRenderState } from './split-trigger-props';

type NavigationItemTriggerProps = {
    item: DropdownNavigationItem;
    onKeyboardClose: () => void;
    triggerProps: TriggerRenderProps;
    triggerState: TriggerRenderState;
};

export function NavigationItemTrigger({
    item,
    onKeyboardClose,
    triggerProps,
    triggerState,
}: NavigationItemTriggerProps) {
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const [openedWithKeyboard, setOpenedWithKeyboard] = useState(false);

    const { buttonProps, groupProps, linkProps } = splitTriggerProps({
        buttonRef,
        isOpen: triggerState.open,
        label: item.title,
        onKeyboardClose,
        onKeyboardOpen: () => setOpenedWithKeyboard(true),
        onPointerOpen: () => setOpenedWithKeyboard(false),
        props: triggerProps,
    });

    return (
        <div
            {...groupProps}
            className="desktop-menu__control"
            data-pointer-open={triggerState.open && !openedWithKeyboard ? '' : undefined}
        >
            <NavigationItemLabel
                {...linkProps}
                emphasis={item.emphasis}
                href={item.href}
                openInNewTab={item.openInNewTab}
                title={item.title}
            />
            <button
                {...buttonProps}
                type="button"
                className="desktop-menu__toggle"
                data-keyboard-open={triggerState.open && openedWithKeyboard ? '' : undefined}
            >
                <Icon name={triggerState.open ? 'chevron-up' : 'chevron-down'} size="sm" />
            </button>
        </div>
    );
}
